import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { NetworkIcon } from 'lucide-react'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const mitmAttackDefinition: SmartSignalDefinition<{ mitm_attack?: boolean }> = {
  key: 'mitm-attack',
  label: 'MitM attack',
  extract: (e) => ({ mitm_attack: e.mitm_attack }),
  icon(e) {
    const p = this.extract(e)?.mitm_attack
    return (
      <NetworkIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.mitm_attack
    return p === true
  },
  isWeb: () => false,
  isMobile: () => true,
  searchFor: '"mitm_attack":',
  documentationHash: '#mitm-attack-detection',
  urlParamKey: IdentificationUrlKeys.MitmAttack,
}
